import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';

export const parsePriceFormat = (price: number, withoutFormat?: boolean): string => {
  const priceString = price.toString();
  const getDecimals = priceString.slice(-2);
  const priceWithOutDecimals = priceString.slice(0, -2);
  const finalPrice = `${priceWithOutDecimals}.${getDecimals}`;
  return withoutFormat ? finalPrice : YayoyakiFormatter.formatAmountMxn(Number(finalPrice));
};

export const calculateCommission = (number: number): string => {
  const commissionRate = 0.15;
  const percentage = number * commissionRate;
  return YayoyakiFormatter.formatAmountMxn(percentage);
};

export const increasePrice = (number: number): string => {
  const porcentaje = number * 0.2;
  const valueWithPercentage = number + porcentaje;
  const roundedValue = Math.ceil(valueWithPercentage / 50) * 50 - 1;
  return YayoyakiFormatter.formatAmountMxn(roundedValue);
};
